// extracted by mini-css-extract-plugin
export default {"PageProductIntroMobileSubcopy":"PageProductIntroMobileSubcopy_PageProductIntroMobileSubcopy__B4KQh"};